import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";

import PhotoWrapper from "components/Homeowner/CaseForms/ReadOnly/PhotoWrapper";

const Photos = ({
  photos,
  token
}) => {
  if (photos && !photos.photoList) {
    return <MSpinner/>;
  }
   
  let photoList = photos.photoList.map((item, ix) => (
    <PhotoWrapper 
      key={item.photoUrl}      
      src={`${item.photoUrl}${token}`}
      tags={item.photoTags}
      desc={item.photoDescription}
      number={ix+1}
    />
  ));

  return (
    <div className="case-header md-grid">
      {photoList}
    </div>  
  );
};

Photos.propTypes = {
  photos: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired
};

export default Photos;